/*
 * @Description:过滤
 * @Author: 山淑兰
 * @Date: 2019-12-26 10:32:28
 * @LastEditTime : 2019-12-27 23:39:16
 * @LastEditors  : 山淑兰
 */

import moment from "moment";

export default {
  filterPlatform(status: string) {
    switch (status) {
      case "35c":
        return "35城";
      case "52c":
        return "52城";
      default:
        return "全国";
    }
  },
};
